import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#1f1f1f] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4">ALIF</h3>
            <p className="text-sm sm:text-base text-gray-300 mb-3 sm:mb-4">
              Transforming ideas into reality through innovation and excellence
              in technology solutions.
            </p>
            <div className="flex space-x-3 sm:space-x-4">
              <a
                href="https://facebook.com"
                className="hover:text-[#B31F7E] transition-colors"
              >
                <FaFacebookF size={20} />
              </a>
              <a
                href="https://twitter.com"
                className="hover:text-[#B31F7E] transition-colors"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="https://linkedin.com"
                className="hover:text-[#B31F7E] transition-colors"
              >
                <FaLinkedinIn size={20} />
              </a>
              <a
                href="https://instagram.com"
                className="hover:text-[#B31F7E] transition-colors"
              >
                <FaInstagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/solutions"
                  className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors"
                >
                  Solutions
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Our Services</h4>
            <ul className="space-y-1 sm:space-y-2">
              <Link to="/solutions/AIConsulting">
                <li className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors mb-3 sm:mb-4">
                  AI Consulting
                </li>
              </Link>
              <Link to="/solutions/business-technology">
                <li className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors mb-3 sm:mb-4">
                  Business & Technology
                  <br /> Consulting
                </li>
              </Link>
              <Link to="/solutions/digital-marketing">
                <li className="text-sm sm:text-base text-gray-300 hover:text-[#B31F7E] transition-colors">
                  Digital Marketing
                </li>
              </Link>
              {/* <li className="text-gray-300">Cybersecurity</li>
              <li className="text-gray-300">IoT Solutions</li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Contact Us</h4>
            <div className="space-y-1 sm:space-y-2">
              <p className="text-sm sm:text-base text-gray-300">
                AL KHABEESI BUILDING,
                <br />
                PLOT 128-246,
                <br />
                M-03 Al Khabeesi, Dubai UAE.
              </p>
              <p className="text-sm sm:text-base text-gray-300">Phone: +971-555-763-441</p>
              <p className="text-sm sm:text-base text-gray-300">Email: info@digitalif.net</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 sm:mt-12 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <p className="text-gray-300 text-xs sm:text-sm">
              © {new Date().getFullYear()} ALIF. All rights reserved.
            </p>
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6 mt-3 sm:mt-0">
              <Link
                to="/privacy"
                className="text-gray-300 text-xs sm:text-sm hover:text-[#B31F7E] transition-colors text-center"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-300 text-xs sm:text-sm hover:text-[#B31F7E] transition-colors text-center"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
